<template>
  <v-app-bar elevate-on-scroll height="90" class="header-oi" app>
    <v-toolbar-title class="text-uppercase">
      <Logo />
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <!-- <v-btn
      text
      large
      class="fale-com-seguranca d-none d-md-flex"
      href="https://wa.me/5521988241660"
      target="_blank"
    >
      <v-icon size="36" color="primary">mdi-whatsapp</v-icon>Fale com a Segurança
    </v-btn>-->
  </v-app-bar>
</template>

<script>
import Logo from "./Logo";
export default {
  components: {
    Logo
  }
};
</script>

<style lang="scss">
.header-oi {
  .v-toolbar__content {
    padding: 4px 60px;
  }
  @media only screen and (min-width: 1400px) {
    .v-toolbar__content {
      padding: 4px 180px;
    }
  }
  @media only screen and (max-width: 414px) {
    .v-toolbar__content {
      padding: 4px 20px;
    }
  }
}
.fale-com-seguranca {
  &.v-btn {
    letter-spacing: 0px !important;
    text-transform: none;
    color: #545454 !important;
  }
  i {
    margin-right: 20px;
  }
}
</style>
